import angular from 'angular';
import 'angular-sanitize';

import HeadlineService from './headline.service';
import HeadlinesController from './headlines.controller';
import headlineAnalysis from './headline_analysis.directive';
import HeadlineModalController from './headline_modal.controller';

angular.module('generator.headlines', [
  'ui.bootstrap',
  'ngSanitize',
  'generator.creativePreview'
]);

angular
  .module('generator.headlines')
  .directive('headlineAnalysis', headlineAnalysis)
  .controller('HeadlinesController', HeadlinesController)
  .controller('HeadlineModalController', HeadlineModalController)
  .service('HeadlineService', HeadlineService);
